import React, { Component } from 'react';
import { Button, Row, Col, Input, Label } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import CompanyContext from '../../auth/CompanyContext';
import ConfirmButton from '../../components/Modal/ConfirmButton';
import { Prompt } from 'react-router-dom';

class Custodians extends Component {
    static contextType = CompanyContext;

    state = {
        custodian: '',
        custodians: [],
        editCustodianId: null,
        editCustodianLabel: '',
        unsavedChanges: false
    };

    componentDidMount() {
        this.getCustodians();
    }

    getCustodians = () => {
        fetch('/api/companies/custodians/configuration', {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => this.setState({
                unsavedChanges: false,
                custodians: results.data || []
            }));
    };

    handleSubmit = () => {
        const custodianLabel = this.state.custodian.trim();
        if (!custodianLabel) return;

        fetch('/api/companies/custodians/configuration', {
            method: 'POST',
            body: JSON.stringify({ custodianLabel }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({ custodian: '', unsavedChanges: false }, this.getCustodians);
                }
            });
    };

    handleDelete = (custodianId) => {
        fetch('/api/companies/custodians/configuration/' + custodianId, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        }).then(() => {
            if (this.state.editCustodianId === custodianId) {
                this.setState({ editCustodianId: null, editCustodianLabel: '', unsavedChanges: false });
            }
            this.getCustodians();
        });
    };

    startEdit = (custodian) => {
        this.setState({
            editCustodianId: custodian.custodianId,
            editCustodianLabel: custodian.custodianLabel,
            unsavedChanges: false
        });
    };

    handleEdit = () => {
        const custodianLabel = this.state.editCustodianLabel.trim();
        if (!this.state.editCustodianId || !custodianLabel) return;

        fetch('/api/companies/custodians/configuration/' + this.state.editCustodianId, {
            method: 'PUT',
            body: JSON.stringify({ custodianLabel }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        editCustodianId: null,
                        editCustodianLabel: '',
                        unsavedChanges: false
                    }, this.getCustodians);
                }
            });
    };

    render() {
        const custodians = [...this.state.custodians].sort((a, b) =>
            String(a.custodianLabel || '').localeCompare(String(b.custodianLabel || ''), undefined, { sensitivity: 'base' })
        );

        return (
            <Row>
                <Prompt
                    when={this.state.unsavedChanges}
                    message="You have unsaved changes, are you sure you want to leave?"
                />
                <Col>
                    <Row>
                        <Col>
                            <Label>Custodian
                                <Input
                                    type="text"
                                    name="custodian"
                                    value={this.state.custodian}
                                    onChange={(e) => this.setState({ custodian: e.target.value, unsavedChanges: true })}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' && this.state.custodian.trim()) {
                                            e.preventDefault();
                                            this.handleSubmit();
                                        }
                                    }}
                                />
                            </Label>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button
                                className="mt-4"
                                disabled={!this.state.custodian.trim()}
                                color="primary"
                                onClick={this.handleSubmit}
                            >Submit</Button>
                        </Col>
                    </Row>
                </Col>
                <Col>
                    {custodians.map(custodian => (
                        <Row key={custodian.custodianId} className="text-left mt-3 align-items-center">
                            <Col md={6}>
                                {this.state.editCustodianId === custodian.custodianId
                                    ? <Input
                                        type="text"
                                        value={this.state.editCustodianLabel}
                                        autoFocus
                                        onChange={(e) => this.setState({ editCustodianLabel: e.target.value, unsavedChanges: true })}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' && this.state.editCustodianLabel.trim()) {
                                                e.preventDefault();
                                                this.handleEdit();
                                            }
                                        }}
                                    />
                                    : custodian.custodianLabel}
                            </Col>
                            <Col md={6}>
                                {this.state.editCustodianId === custodian.custodianId
                                    ? <Button
                                        className="mx-1"
                                        color="success"
                                        disabled={!this.state.editCustodianLabel.trim()}
                                        onClick={this.handleEdit}
                                        title="Save Custodian"
                                    >
                                        <FontAwesomeIcon icon={faCheck} />
                                    </Button>
                                    : <Button
                                        className="mx-1"
                                        color="primary"
                                        onClick={() => this.startEdit(custodian)}
                                        title="Edit Custodian"
                                    >
                                        <FontAwesomeIcon icon={faEdit} />
                                    </Button>}
                                <ConfirmButton
                                    className="mx-1"
                                    color="danger"
                                    onClick={() => this.handleDelete(custodian.custodianId)}
                                    title="Delete Custodian"
                                >
                                    <FontAwesomeIcon icon={faTrashAlt} />
                                </ConfirmButton>
                            </Col>
                        </Row>
                    ))}
                </Col>
            </Row>
        );
    }
}

export default Custodians;
